<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          @click="newTransfer"
          v-if="auth.can('ADD_VIREMENT')"
        >
          Nouveau Virement
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
          @change="getRecords()"
          @input="getRecords"
          v-model="users.searchTerm"
        />

        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="columns" :rows="rows" responsive>
        <template v-slot:emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <span v-if="props.column.field === 'ref'" class="text-nowrap">
            <b>{{ props.row.ref }}</b>
          </span>

          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null"
              >{{ getDate(props.row.created_at) }}<br
            /></template>
            {{ props.row.c_by_name }}
          </span>
          <span v-else-if="props.column.field === 'p_time'" class="text-nowrap">
            <template v-if="props.row.p_time != null"
              >{{ getDate(props.row.p_time) }}<br
            /></template>
            {{ props.row.p_by_name }}
          </span>
          <span
            v-else-if="props.column.field === 'total_to_send'"
            class="text-nowrap"
          >
            {{ props.row.total_to_send }} DH
          </span>

          <span
            v-else-if="props.column.field === 'total_inv'"
            class="text-nowrap"
          >
            {{ props.row.total_inv }}
          </span>

          <template v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut == 0"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.statut
              )}`"
              class="text-capitalize"
            >
              Nouveau
            </span>

            <span
              v-else-if="props.row.statut == 1"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.statut
              )}`"
              class="text-capitalize"
            >
              Payé
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <router-link
                    class="dropdown-item"
                    :to="`/edit-virements/${props.row.id}/${props.row.ref}`"
                  >
                    <i class="flaticon-edit"></i> Modifier
                  </router-link>
                </li>
                <li v-if="props.row.statut == 0 && props.row.total_inv == 0">
                  <button class="dropdown-item" @click="DestroyVire(props.row)">
                    <i class="flaticon-delete"></i> Supprimer
                  </button>
                </li>
                <li
                  v-if="
                    props.row.statut == 0 &&
                    props.row.total_inv != 0 &&
                    props.row.total_to_send != 0
                  "
                >
                  <button class="dropdown-item" @click="PaidVire(props.row)">
                    <i class="flaticon-check"></i> Payé
                  </button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    @click="ExportTransfer(props.row)"
                  >
                    <i class="flaticon-download"></i> Exporter
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="PDFTransfer(props.row)">
                    <i class="flaticon-file"></i> Télécharger
                  </button>
                </li>
              </ul>
            </div>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>
</template>

<script>
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import moment from "moment";

export default defineComponent({
  name: "InvoiceList",
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const pageLength = ref(10);
    const loading = ref(false);
    const columns = [
      { label: "Référence", field: "ref" },
      { label: "Date de création", field: "created_at" },
      { label: "Date de paiement", field: "p_time" },
      { label: "Statut", field: "statut" },
      { label: "Factures", field: "total_inv" },
      { label: "Total", field: "total_to_send" },
      { label: "Actions", field: "action", width: "180px" },
    ];
    const rows = ref([]);
    const users = ref({
      searchTerm: "",
      searchStatut: "",
      searchDateCS: "",
      searchDateCE: "",
      searchDatePS: "",
      searchDatePE: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const offset = ref(9);
    const status_filter = ref("");
    const debounceTimer = ref(null);

    function resolveUserStatusVariant(status) {
      if (status === 0) return "danger";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "warning";
    }

    function newTransfer() {
      const data = new FormData();
      data.append("user_id", user.id);
      data.append("user_name", user.name || "");
      loading.value = true;
      api
        .post(`/api/auth/add_transfer`, data)
        .then((res) => {
          loading.value = false;
          if (res.data.message === "success") {
            // Use router from vue-router composable
            window.location.href = `/edit-virements/${res.data.data?.id}/${res.data.data?.ref}`;
          }
        })
        .catch(() => {
          showToast("Something went wrong! Please try again", "error");
        });
    }
    function getRecords(page = 1) {
      loading.value = true;
      users.value.current_page = page;
      api
        .get(`/api/auth/transfers_list`, {
          params: {
            searchTerm: users.value.searchTerm,
            searchStatut: users.value.searchStatut,
            searchDateCS: users.value.searchDateCS,
            searchDateCE: users.value.searchDateCE,
            searchDatePS: users.value.searchDatePS,
            searchDatePE: users.value.searchDatePE,
            page: users.value.current_page,
            per_page: users.value.per_page,
          },
        })
        .then((response) => {
          rows.value = response.data.users.data;
          users.value = response.data.users;
        })
        .finally(() => {
          loading.value = false;
        });
    }

    function DestroyVire(row) {
      api.post(`/api/auth/destroy_trnsf/${row.id}`).then((res) => {
        if (res.data.message === "success") {
          getRecords();
          showToast("Virement est supprimé", "success");
        } else {
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      });
    }

    function PaidVire(row) {
      // You can use a modal here if needed
      api
        .post(`/api/auth/paid_trnsf/${row.id}`, {
          UserID: user.id,
          user_name: user.name || "admin",
        })
        .then((res) => {
          if (res.data.message === "success") {
            getRecords();
          } else {
            showToast("Erreur lors du paiement", "error");
          }
        });
    }

    function ExportTransfer(row) {
      api
        .get(`/api/auth/ExportTransfer/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          const fileURL = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = `${row.ref}.xlsx`;
          fileLink.click();
        });
    }

    function PDFTransfer(row) {
      api
        .get(`/api/auth/TransfertPDF/${row.id}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, "_blank");
        });
    }

    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function filter() {
      users.value.searchStatut = status_filter.value;
      getRecords();
    }

    function Removefilter() {
      users.value.searchStatut = "";
      users.value.searchDateCS = "";
      users.value.searchDateCE = "";
      users.value.searchDatePS = "";
      users.value.searchDatePE = "";
      users.value.searchTerm = "";
      status_filter.value = "";
      getRecords();
    }

    function handleInput(e) {
      clearTimeout(debounceTimer.value);
      debounceTimer.value = setTimeout(() => {
        users.value.searchTerm = e.target.value;
        filter();
      }, 500);
    }

    function getDate(str) {
      // if (!str) return "";
      // const date = new Date(str);
      // return date.toLocaleDateString();
       if (str) return moment(String(str)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    onMounted(() => {
      getRecords();
    });

    return {
      auth,
      user,
      columns,
      rows,
      users,
      offset,
      status_filter,
      resolveUserStatusVariant,
      getRecords,
      DestroyVire,
      PaidVire,
      ExportTransfer,
      PDFTransfer,
      convert,
      filter,
      Removefilter,
      handleInput,
      getDate,
      loading,
      pageLength,
      newTransfer,
    };
  },
});
</script>